import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type OfferOption = 'neon' | 'combo' | 'superCombo';
export function UpsellBox() {
  const [selected, setSelected] = useState<OfferOption>('superCombo');
  const offers = {
    neon: {
      label: 'Oferta principal',
      title: 'Neon Flex Digital',
      description: <div className="space-y-2" data-id="element-251" data-mp="1y8i75hqisaw1">
          <p className="font-bold text-[13px] text-[#1B00FF]" data-id="element-252" data-mp="1ahvzhrkfgsmk">
            🚀 Todo para dominar el Neon Flex:
          </p>
          <ul className="space-y-1 list-disc list-inside" data-id="element-253" data-mp="15jujxgm7nbfu">
            <li className="text-[14px]" data-id="element-254" data-mp="15lf9ssxky67d">Libro Principal NeonFlex Digital</li>
            <li className="text-[14px]" data-id="element-255" data-mp="1khmwq10dhlqc">6 Bonus Exclusivos</li>
          </ul>
          <p className="font-medium italic" data-id="element-256" data-mp="1fgfpc3256ok7">Ideal para empezar desde cero.</p>
        </div>,
      price: '$19.990',
      oldPrice: '$39.990',
      image: 'https://cdn.magicpatterns.com/uploads/uWUafb1NTfvXy4rEiHyzsm/111111.webp',
      checkoutUrl: 'https://www.digital-factory.store/cart/46890834722900:1'
    },
    combo: {
      label: 'Combo especial',
      title: 'Neon Flex + Mesas y Espejos Infinitos',
      description: <div className="space-y-2" data-id="element-257" data-mp="26pu1xei6yb4r">
          <p className="font-bold text-[13px] text-[#1D12EE]" data-id="element-258" data-mp="26qvhnwa5jlst">
            💎 Accedé a 2 capacitaciones completas por una diferencia mínima:
          </p>
          <ul className="space-y-1 list-disc list-inside" data-id="element-259" data-mp="1e14znc5efzrf">
            <li className="text-[14px]" data-id="element-260" data-mp="1e2ptezjw3eo8">Neon Flex + 6 Bonus</li>
            <li className="text-[14px]" data-id="element-261" data-mp="1izq11ewe0phg">Mesas y Espejos Infinitos + 5 Bonus</li>
          </ul>
          <p className="font-medium italic" data-id="element-262" data-mp="1n1b9mo1w2hlu">
            Más valor. Más contenido. Más oportunidades.
          </p>
        </div>,
      price: '$25.990',
      oldPrice: '$55.990',
      image: 'https://cdn.magicpatterns.com/uploads/555GytoS73nwsRvP8qoszs/ChatGPT_Image_29_may_2026,_15_28_42.webp',
      checkoutUrl: 'https://www.digital-factory.store/cart/46918176309332:1'
    },
    superCombo: {
      label: 'Combo super especial',
      title: 'Neon Flex + Mesas y Espejos Infinitos + Resina Epoxica',
      description: <div className="space-y-2" data-id="element-263" data-mp="1xnt887c1md9f">
          <p className="font-bold text-[13px] text-[#1D12EE]" data-id="element-264" data-mp="2cczegf9at3qt">
            💎 Accedé a 3 capacitaciones completas por una diferencia mínima:
          </p>
          <ul className="space-y-1 list-disc list-inside" data-id="element-265" data-mp="27eeemgxykm2w">
            <li className="text-[14px]" data-id="element-266" data-mp="1jns8wwbffdw2">Neon Flex + 6 Bonus</li>
            <li className="text-[14px]" data-id="element-267" data-mp="1jq4zfxv92wkq">Mesas y Espejos Infinitos + 5 Bonus</li>
            <li className="text-[14px]" data-id="element-268" data-mp="1er1sg7vpmga4">Resina Epoxica + 5 Bonus</li>
          </ul>
          <p className="font-medium italic" data-id="element-269" data-mp="1sprorlapgbxf">
            Más valor. Más contenido. Más oportunidades.
          </p>
        </div>,
      price: '$30.990',
      oldPrice: '$70.990',
      image: 'https://cdn.magicpatterns.com/uploads/xpZ5YpWDAZfDwRUjSNYb9w/ChatGPT_Image_25_jun_2026,_14_21_30.webp',
      checkoutUrl: 'https://www.digital-factory.store/cart/47254351839316:1',
      popular: true
    }
  };
  return <section id="pricing" className="py-20 px-4 relative z-10 bg-transparent pt-[8px] pb-[8px]" data-id="element-270" data-mp="37o5nl17zc40m">
      <div className="max-w-[1000px] mx-auto p-[18px] rounded-[18px] bg-[#f3f4f6] border border-gray-300 shadow-[0_0_28px_rgba(0,0,0,0.1)]" data-id="element-271" data-mp="2xnwrdndzmil8">
        <h3 className="text-center text-gray-900 text-[22px] mb-[14px] font-black tracking-tight" data-id="element-272" data-mp="32o173b72n9ae">
          Elegí tu oferta especial
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[12px]" data-id="element-273" data-mp="3qewy463pe0gl">
          {/* Neon Option */}
          <div onClick={() => setSelected('neon')} className={`relative p-[14px] rounded-[14px] border cursor-pointer transition-all duration-250 flex flex-col ${selected === 'neon' ? 'bg-white border-[#00f0ff] shadow-[0_0_22px_rgba(0,240,255,0.25)] -translate-y-[1px]' : 'bg-white/50 border-gray-200 hover:border-gray-300'}`} data-id="element-274" data-mp="3vdhws13b4c2x">
            <span className="font-bold uppercase tracking-wider text-[12px] text-[#C90EEE]" data-id="element-275" data-mp="hybvd71o03lx">
              {offers.neon.label}
            </span>
            <h4 className="text-gray-900 text-[17px] my-[4px] font-black leading-tight" data-id="element-276" data-mp="2leqmszrxt4up">
              {offers.neon.title}
            </h4>
            <div className="text-[11px] leading-[1.3] mb-[8px] flex-grow text-[#00080F]" data-id="element-277" data-mp="2ggf9gf2foc7q">
              {offers.neon.description}
            </div>
            <div className="mb-3" data-id="element-278" data-mp="2bix6r6f0et86">
              <span className="text-sm line-through block leading-none mb-1 text-[#E00606]" data-id="element-279" data-mp="394kvr694y99o">
                {offers.neon.oldPrice}
              </span>
              <strong className="block text-[22px] font-black leading-none text-[#0ABF16]" data-id="element-280" data-mp="347kois0jv0gz">
                {offers.neon.price}
              </strong>
            </div>
            <button className={`${`w-full py-1.5 rounded-lg font-bold text-xs transition-all ${selected === 'neon' ? 'bg-[#00f0ff] text-white shadow-lg' : 'bg-gray-100 text-gray-400'}`} bg-[#0CD813]`} data-id="element-281" data-mp="2uenaay2lbxo6">
              {selected === 'neon' ? 'SELECCIONADO' : 'SELECCIONAR'}
            </button>
          </div>

          {/* Combo Option */}
          <div onClick={() => setSelected('combo')} className={`relative p-[14px] rounded-[14px] border cursor-pointer transition-all duration-250 flex flex-col ${selected === 'combo' ? 'bg-white border-[#00f0ff] shadow-[0_0_22px_rgba(0,240,255,0.25)] -translate-y-[1px]' : 'bg-white/50 border-gray-200 hover:border-gray-300'}`} data-id="element-282" data-mp="38ebeb7hfg8v">
            <span className="font-bold uppercase tracking-wider text-[12px] text-[#B404F3]" data-id="element-283" data-mp="i4dra80u2kok">
              {offers.combo.label}
            </span>
            <h4 className="text-gray-900 text-[17px] my-[4px] font-black leading-tight" data-id="element-284" data-mp="qzjq2n1os2hl">
              {offers.combo.title}
            </h4>
            <div className="text-[11px] leading-[1.3] mb-[8px] flex-grow text-[#020814]" data-id="element-285" data-mp="vzpkuc39653w">
              {offers.combo.description}
            </div>
            <div className="mb-3" data-id="element-286" data-mp="15uzpl7l1cqld">
              <span className="text-sm line-through block leading-none mb-1 text-[#E60E27]" data-id="element-287" data-mp="15w109ay53b2k">
                {offers.combo.oldPrice}
              </span>
              <strong className="block text-[22px] font-black leading-none text-[#0CC51F]" data-id="element-288" data-mp="b92gzcqini1t">
                {offers.combo.price}
              </strong>
            </div>
            <button className={`${`w-full py-1.5 rounded-lg font-bold text-xs transition-all ${selected === 'combo' ? 'bg-[#00f0ff] text-white shadow-lg' : 'bg-gray-100 text-gray-400'}`} bg-[#09DC25]`} data-id="element-289" data-mp="pz9st9m0q2tj">
              {selected === 'combo' ? 'SELECCIONADO' : 'SELECCIONAR'}
            </button>
          </div>

          {/* Super Combo Option */}
          <div onClick={() => setSelected('superCombo')} className={`relative p-[14px] rounded-[14px] border cursor-pointer transition-all duration-250 flex flex-col ${selected === 'superCombo' ? 'bg-white border-[#00f0ff] shadow-[0_0_22px_rgba(0,240,255,0.25)] -translate-y-[1px]' : 'bg-white/50 border-gray-200 hover:border-gray-300'}`} data-id="element-290" data-mp="18vjdifrfdrmi">
            <div className="absolute -top-[10px] right-[10px] text-gray-900 px-[8px] py-[3px] rounded-full font-black shadow-[0_0_10px_rgba(251,191,36,0.3)] z-10 bg-[#F5F52C] text-[12px]" data-id="element-291" data-mp="1l7lgq1tv3e8v">
              ★ Más elegido
            </div>

            <span className="font-bold uppercase tracking-wider text-[12px] text-[#B404F3]" data-id="element-292" data-mp="1bempec6zd9lk">
              {offers.superCombo.label}
            </span>
            <h4 className="text-gray-900 text-[17px] my-[4px] font-black leading-tight" data-id="element-293" data-mp="12fsvwuoy4zc8">
              {offers.superCombo.title}
            </h4>
            <div className="text-[11px] leading-[1.3] mb-[8px] flex-grow text-[#020814]" data-id="element-294" data-mp="16fjlww6nfbfp">
              {offers.superCombo.description}
            </div>
            <div className="mb-3" data-id="element-295" data-mp="xg6cg3iiymuz">
              <span className="text-sm line-through block leading-none mb-1 text-[#E60E27]" data-id="element-296" data-mp="xh7wgxhiqjou">
                {offers.superCombo.oldPrice}
              </span>
              <strong className="block text-[22px] font-black leading-none text-[#0CC51F]" data-id="element-297" data-mp="2rv8vpjgzd8pg">
                {'$29.990'}
              </strong>
            </div>
            <button className={`${`w-full py-1.5 rounded-lg font-bold text-xs transition-all ${selected === 'superCombo' ? 'bg-[#00f0ff] text-white shadow-lg' : 'bg-gray-100 text-gray-400'}`} bg-[#09DC25]`} data-id="element-298" data-mp="1epyt23nlxpc9">
              {selected === 'superCombo' ? 'SELECCIONADO' : 'SELECCIONAR'}
            </button>
          </div>
        </div>

        <div className="mt-[16px] relative rounded-[16px] overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] bg-white" data-id="element-299" data-mp="vyfuqa4j2zgk">
          <AnimatePresence mode="wait" data-id="element-300" data-mp="r0o038ci0z8o">
            <motion.img key={selected} initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 1.05
          }} transition={{
            duration: 0.3
          }} src={offers[selected].image} alt="Oferta seleccionada" className="w-full h-auto block mx-auto" data-id="element-301" data-mp="mwgaza24ph9x" />
          </AnimatePresence>
        </div>

        <div className="mt-8" data-id="element-302" data-mp="2tkyr2frv9ga4">
          <a href={offers[selected].checkoutUrl} className="block w-full py-5 rounded-xl bg-gradient-to-r from-[#ec4899] to-[#8b5cf6] text-white text-center font-black text-xl uppercase tracking-widest shadow-[0_10px_30px_rgba(236,72,153,0.3)] hover:scale-[1.01] active:scale-[0.98] transition-all" data-id="element-303" data-mp="2tm0ezktzdx99">
            ¡COMPRAR AHORA!
          </a>
          <p className="text-center text-gray-400 text-xs mt-4 font-bold uppercase tracking-widest" data-id="element-304" data-mp="2ato5me4wtvpm">
            🔒 Pago Seguro • Acceso Inmediato • 7 Días de Garantía
          </p>
        </div>

        {/* Mercado Pago Trust Image */}
        <div className="mt-8 -mx-[18px] -mb-[18px] border-t border-gray-200 overflow-hidden rounded-b-[18px]" data-id="element-305" data-mp="3mbyvusy0uo2u">
          <img src="https://cdn.magicpatterns.com/uploads/uUsHE36gY1b2kZZniihejK/ChatGPT_Image_29_may_2026,_16_20_08.webp" alt="Mercado Pago Trust" className="w-full h-auto block" data-id="element-306" data-mp="3qdc0x0tain8p" />
        </div>
      </div>
    </section>;
}